/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsHockeyIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-hockey"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.55 19.3L1.55 16.85Q1.55 16.4 1.88 16.07Q2.2 15.75 2.65 15.75L3.75 15.75L3.75 20.4L2.65 20.4Q2.2 20.4 1.88 20.07Q1.55 19.75 1.55 19.3ZM4.75 20.4L4.75 15.75L8.75 15.75L9.6 13.85L11.55 18.1L10.75 19.85Q10.63 20.13 10.38 20.26Q10.13 20.4 9.85 20.4ZM22.5 19.3Q22.5 19.75 22.18 20.07Q21.85 20.4 21.4 20.4L20.3 20.4L20.3 15.75L21.4 15.75Q21.85 15.75 22.18 16.07Q22.5 16.4 22.5 16.85ZM19.3 20.4L14.2 20.4Q13.93 20.4 13.68 20.26Q13.43 20.13 13.3 19.85L7 6.1Q6.58 5.17 7.11 4.34Q7.65 3.5 8.68 3.5Q9.25 3.5 9.71 3.8Q10.18 4.1 10.4 4.63L12 8.35L13.68 4.58Q13.9 4.08 14.35 3.79Q14.8 3.5 15.35 3.5Q16.38 3.5 16.91 4.36Q17.45 5.22 17.02 6.15L13.95 12.8L15.3 15.75L19.3 15.75Z" fill={color} />
    </svg>
  );
}
